export default __webpack_public_path__ + "assets/uv-index-10.9dc9b4de.svg";